<template>
  <v-layout column class="ml-2">
    <h1>FILTER IS HERE</h1><br /><br />
    <v-form>
      <v-range-slider label="Age range:" max=20 min=7 thumb-label="always" v-model="ageRange"></v-range-slider>
      <v-btn>Apply Filters</v-btn>
    </v-form>
  </v-layout>
</template>

<script>
import utils from '../../../utils.ts'

export default {
  name: 'IdeaFilter',
  components: {
  },
  data () {
    return {
      ageRange: [7, 20],
    }
  },
  computed: {

  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */


</style>
